import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import ArrivalDepartureFilter from '../store/ArrivalDepartureFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import StayDurationTypeState from '../store/StayDurationTypeState';

export default class StayDurationTypeToArrivalDepartureConnector implements Observer {
    readonly #arrivalDepartureFilter: ArrivalDepartureFilter;

    private constructor(arrivalDepartureFilter: ArrivalDepartureFilter) {
        this.#arrivalDepartureFilter = arrivalDepartureFilter;
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof StayDurationTypeState)) {
            return;
        }

        this.#arrivalDepartureFilter.enabled = subject.type === 'calendar';
    }

    public static connect(): void {
        const state = StayDurationTypeState.getInstance();
        const filters = HouseSearchFilters.getInstance();
        const arrivalDepartureFilter = filters.get(ArrivalDepartureFilter.NAME) as
            | ArrivalDepartureFilter
            | undefined;

        if (!arrivalDepartureFilter) return;

        const connector = new StayDurationTypeToArrivalDepartureConnector(arrivalDepartureFilter);
        state.attach(connector);
    }
}
